import { ResourceInfoDc, ResourceTypeLink } from "@evergis/api";
import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { getUsername } from "../../../../ducks/user";
import { LayerReferencesTooltip } from "../../DeleteLayer/LayerReferencesTooltip";

type ResourcesTooltipProps = {
  resources: ResourceInfoDc[];
  resourceType: ResourceTypeLink;
};

export const ResourcesTooltip: FC<ResourcesTooltipProps> = ({ resources, resourceType }) => {
  const currentUser: string = useSelector(getUsername);
  const resourcesNames = useMemo(
    () =>
      !resources
        ? {
            my: [],
            others: [],
          }
        : resources.reduce(
            (acc, { name, alias }) =>
              name.startsWith(currentUser)
                ? { ...acc, my: [...acc.my, alias || name] }
                : { ...acc, others: [...acc.others, alias || name] },
            {
              my: [],
              others: [],
            },
          ),
    [resources, currentUser],
  );

  return (
    <LayerReferencesTooltip
      resourceType={resourceType}
      references={resourcesNames.my}
      otherReferences={resourcesNames.others}
    />
  );
};
